import React from "react";
import TeamTwo from "../Team/TeamTwo";

const TrainerSection = () => {
  return (
    <div className="container">
      <div className="row mb--60">
        <div className="col-lg-12">
          <div className="section-title text-center">
            <span className="subtitle bg-primary-opacity">Our Teacher</span>
            <h2 className="title">Whose Inspirations You</h2>
          </div>
        </div>
      </div>
      <TeamTwo />
    </div>
  );
};

export default TrainerSection;
